<ion-item class="input-toggle">
  <ion-toggle [(ngModel)]="left" justify="start" (ionChange)="onToggleChange()"
    >Image à gauche</ion-toggle
  >
</ion-item>
<editor
  [init]="{ plugins: 'lists link image table code help wordcount', language: 'fr_FR' }"
  [apiKey]="tinyMceKey"
  class="my-4"
  (onFocusOut)="onEditorChange()"
  [(ngModel)]="text"
></editor>
<ion-list lines="none" class="w-full flex flex-col gap-4 py-4">
  <!-- <ion-item class="input-label">
    <ion-input
      type="text"
      fill="outline"
      label="Lien de l'image"
      label-placement="floating"
      color="primary"
      [(ngModel)]="image"
      (ionChange)="onInputChange()"
    ></ion-input>
  </ion-item> -->
  <app-file-upload [files]="image" (inputChange)="onInputChange($event)" [fileUploadInputs]="fileUploadInputs" [blocIndex]="blocIndex"></app-file-upload>
</ion-list>
